import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import authService from '../services/auth';
import { useLocation } from 'react-router-dom';

const LoginContainer = styled.div`
  max-width: 400px;
  margin: 100px auto;
  padding: 30px;
  border-radius: ${props => props.theme.borderRadius.medium};
  box-shadow: ${props => props.theme.shadows.medium};
  background-color: ${props => props.theme.colors.light};
`;

const Logo = styled.div`
  text-align: center;
  margin-bottom: 30px;
  
  h1 {
    color: ${props => props.theme.colors.primary};
    margin: 0;
  }
  
  p {
    color: ${props => props.theme.colors.dark};
    margin-top: 5px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid ${props => props.theme.colors.gray};
  border-radius: ${props => props.theme.borderRadius.small};
  font-size: 1rem;
`;

const SubmitButton = styled.button`
  width: 100%;
  background-color: ${props => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 12px;
  border-radius: ${props => props.theme.borderRadius.small};
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.theme.colors.primaryDark || props.theme.colors.primary};
    opacity: 0.9;
  }
  
  &:disabled {
    background-color: ${props => props.theme.colors.gray};
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.danger};
  margin-top: 20px;
  padding: 10px;
  background-color: ${props => props.theme.colors.dangerLight || '#ffebee'};
  border-radius: ${props => props.theme.borderRadius.small};
  text-align: center;
`;

const AdminLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (authService.isLoggedIn() && location.pathname !== '/admin') {
            console.log("User is already logged in, navigating to /admin");
            navigate('/admin');
        }
    }, [navigate, location.pathname]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            if (!formData.username.trim() || !formData.password.trim()) {
                throw new Error('Le nom d\'utilisateur et le mot de passe sont requis');
            }

            const result = await authService.login(formData.username, formData.password);

            if (result) {
                console.log("Login successful, navigating to /admin");
                navigate('/admin');
                console.log("Navigation called");
            } else {
                throw new Error('Erreur lors de la connexion');
            }
        } catch (err) {
            console.error('Erreur de connexion:', err);
            setError(err.message || 'Nom d\'utilisateur ou mot de passe incorrect');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <LoginContainer>
            <Logo>
                <h1>Decko</h1>
                <p>Administration</p>
            </Logo>

            <form onSubmit={handleSubmit}>
                <FormGroup>
                    <Label htmlFor="username">Nom d'utilisateur</Label>
                    <Input
                        type="text"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        autoFocus
                    />
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="password">Mot de passe</Label>
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />
                </FormGroup>

                <SubmitButton type="submit" disabled={isLoading}>
                    {isLoading ? 'Connexion...' : 'Se connecter'}
                </SubmitButton>

                {error && <ErrorMessage>{error}</ErrorMessage>}
            </form>
        </LoginContainer>
    );
};

export default AdminLogin;


